import Vue from 'vue';
import App from './App.vue';
import './styles/app.scss';

Vue.config.productionTip = false;

new Vue({
  el: '#phila-site-wide-alerts',
  render (h) {
    return h(App, {});
  },
});
